import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../environments/environment';

export interface PipeInventoryDialogData {
  pipe_id?: number;
  pipe_tubo_type?: string;
  qty_on_stock?: number;
  area_code?: number;
  exp_category_id?: number;
  zone?: number;
  unit_cost?: number;
  minimum_stock?: number;
  maximum_stock?: number;
  reorder_point?: number;
  notes?: string;
  status?: string;
}

@Component({
  selector: 'app-pipe-inventory-dialog',
  templateUrl: './pipe-inventory-dialog.component.html',
  styleUrls: ['./pipe-inventory-dialog.component.scss']
})
export class PipeInventoryDialogComponent {
  pipeForm: FormGroup;
  categories: any[] = [];
  expenseCategories: any[] = [];
  areas: any[] = [];
  isEditMode = false;
  loading = false;

  constructor(
    private dialogRef: MatDialogRef<PipeInventoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PipeInventoryDialogData,
    private fb: FormBuilder,
    private http: HttpClient
  ) {
    this.isEditMode = !!data.pipe_id;
    this.initForm();
    this.loadDropdownData();
  }

  initForm(): void {
    this.pipeForm = this.fb.group({
      pipe_tubo_type: [this.data.pipe_tubo_type || '', Validators.required],
      qty_on_stock: [this.data.qty_on_stock || 0, [Validators.required, Validators.min(0)]],
      area_code: [this.data.area_code || '', Validators.required],
      exp_category_id: [this.data.exp_category_id || '', Validators.required],
      zone: [this.data.zone || 1, [Validators.required, Validators.min(1)]],
      unit_cost: [this.data.unit_cost || 0, [Validators.required, Validators.min(0)]],
      minimum_stock: [this.data.minimum_stock || 0, [Validators.min(0)]],
      maximum_stock: [this.data.maximum_stock || 0, [Validators.min(0)]],
      reorder_point: [this.data.reorder_point || 0, [Validators.min(0)]],
      notes: [this.data.notes || ''],
      status: [this.data.status || 'active', Validators.required]
    });
  }

  loadDropdownData(): void {
    // Load expense sub-categories
    this.http.get(`${environment.apiServiceBaseUrl}/hawdco/expense-sub-categories`).subscribe({
      next: (data: any) => {
        this.categories = data;
        this.expenseCategories = data;
      },
      error: (error) => {
        console.error('Error loading categories:', error);
      }
    });

    // Load areas
    this.http.get(`${environment.apiServiceBaseUrl}/hawdco/areas`).subscribe({
      next: (data: any) => {
        this.areas = data;
      },
      error: (error) => {
        console.error('Error loading areas:', error);
      }
    });
  }

  onSave(): void {
    if (this.pipeForm.invalid) {
      this.pipeForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    const formData = this.pipeForm.value;

    if (this.isEditMode) {
      formData.pipe_id = this.data.pipe_id;
    }

    this.dialogRef.close(formData);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  calculateTotalValue(): number {
    const qty = this.pipeForm.get('qty_on_stock')?.value || 0;
    const cost = this.pipeForm.get('unit_cost')?.value || 0;
    return qty * cost;
  }

  // Auto-calculate reorder point based on minimum stock
  calculateReorderPoint(): void {
    const minStock = this.pipeForm.get('minimum_stock')?.value || 0;
    const reorderPoint = Math.ceil(minStock * 1.2); // 20% above minimum
    this.pipeForm.get('reorder_point')?.setValue(reorderPoint);
  }
}
